// src/components/layouts/app/header/desktop/CompteMenu.tsx
import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { User, ChevronDown, LogIn, UserPlus, Key, Eye } from 'lucide-react';

interface CompteMenuProps {
  onLoginClick?: () => void;
  onRegisterClick?: () => void;
  onForgotPasswordClick?: () => void;
  onContinueWithoutAccount?: () => void;
}

export const CompteMenu: React.FC<CompteMenuProps> = ({
  onLoginClick,
  onRegisterClick,
  onForgotPasswordClick,
  onContinueWithoutAccount,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const timeoutRef = useRef<number | undefined>(undefined);

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = window.setTimeout(() => {
      setIsOpen(false);
    }, 150);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <div
      className="relative"
      ref={containerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className="flex items-center gap-2 px-4 py-2 rounded-full bg-gray-200 text-black hover:bg-primary hover:text-white transition-all duration-200"
      >
        <User className="w-4 h-4" />
        <span className="text-sm font-medium">Mon compte</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      <div
        className={`
          absolute top-full right-0 mt-2 w-56 bg-white border border-gray-200 rounded-xl shadow-lg z-20 overflow-hidden
          transition-all duration-300 ease-out origin-top
          ${isOpen
            ? 'opacity-100 scale-y-100 visible pointer-events-auto'
            : 'opacity-0 scale-y-0 invisible pointer-events-none'
          }
        `}
      >
        <div className="py-2">
          <button
            onClick={() => {
              onLoginClick?.();
              setIsOpen(false);
            }}
            className="w-full text-left px-4 py-2.5 text-sm text-black hover:bg-gray-100 flex items-center gap-3 transition-colors"
          >
            <LogIn className="w-4 h-4 text-primary" />
            Se connecter
          </button>
          <button
            onClick={() => {
              onRegisterClick?.();
              setIsOpen(false);
            }}
            className="w-full text-left px-4 py-2.5 text-sm text-black hover:bg-gray-100 flex items-center gap-3 transition-colors"
          >
            <UserPlus className="w-4 h-4 text-primary" />
            Créer un compte
          </button>
          <button
            onClick={() => {
              onForgotPasswordClick?.();
              setIsOpen(false);
            }}
            className="w-full text-left px-4 py-2.5 text-sm text-black hover:bg-gray-100 flex items-center gap-3 transition-colors"
          >
            <Key className="w-4 h-4 text-primary" />
            Mot de passe oublié
          </button>
          <div className="border-t border-gray-100 my-1" />
          <button
            onClick={() => {
              onContinueWithoutAccount?.();
              setIsOpen(false);
            }}
            className="w-full text-left px-4 py-2.5 text-sm text-black hover:bg-gray-100 flex items-center gap-3 transition-colors"
          >
            <Eye className="w-4 h-4 text-primary" />
            Continuer sans compte
          </button>
        </div>
      </div>
    </div>
  );
};